import BrandHealth from './brandHealth'

export default BrandHealth
